/**
 * Generated bundle index. Do not edit.
 */
export { MAT_MENU_SCROLL_STRATEGY, fadeInItems, transformMenu, MatMenuModule, MatMenu, MAT_MENU_DEFAULT_OPTIONS, MatMenuItem, MatMenuTrigger } from './public-api';
export { MatMenuItemBase as ɵa22, _MatMenuItemMixinBase as ɵb22 } from './menu-item';
export { MAT_MENU_SCROLL_STRATEGY_PROVIDER as ɵd22, MAT_MENU_SCROLL_STRATEGY_PROVIDER_FACTORY as ɵc22 } from './menu-trigger';
//# sourceMappingURL=index.js.map